import React__default from 'react';

const width = 20;
const height = 20;
const IconSuperscript = ({ fill = 'black', size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M 15.638672 0 L 13.525391 6.3417969 L 14.474609 6.6582031 L 15.027344 5 L 17.972656 5 L 18.525391 6.6582031 L 19.474609 6.3417969 L 17.359375 0 L 15.638672 0 z M 16.359375 1 L 16.638672 1 L 17.638672 4 L 15.359375 4 L 16.359375 1 z M 5.6523438 4 L 1.03125 16.324219 L 1.96875 16.675781 L 3.3476562 13 L 9.6523438 13 L 11.03125 16.675781 L 11.96875 16.324219 L 7.3476562 4 L 5.6523438 4 z M 6.3476562 5.0019531 L 6.6523438 5.0019531 L 9.2773438 12 L 3.7226562 12 L 6.3476562 5.0019531 z ", fill: fill })));
};

export { IconSuperscript as default };
//# sourceMappingURL=IconSuperscript.js.map
